import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-landnavbar',
  templateUrl: './landnavbar.component.html',
  styleUrls: ['./landnavbar.component.css']
})
export class LandnavbarComponent implements OnInit {

  constructor(private router: Router) { 
    
  }

  isShow: boolean = true;
  isnotOpen: boolean = true;
  isScreen: boolean;

  ngOnInit(): void {
    if(window.screen.width>=768){
      this.isScreen = true
    }
    else{
      this.isScreen = false
    }
  }

  status: boolean = false;
  clickEvent(){
      this.status = !this.status;       
  }

  register(){
    this.router.navigateByUrl('/login')
    // Swal.fire('Registration has been Closed!')
  }

  mid = document.querySelector("#mid")
  // toggleDisplay(event:any) {
  //   this.isShow = !this.isShow;
  //   this.isnotOpen = !this.isnotOpen;
  //   // event.srcElement.classList.toggle("static");
  // }

  toggleDisplay(event: any) {
    this.isShow = !this.isShow;
    this.isnotOpen = !this.isnotOpen;
 
    const nav = document.querySelector('.navbar-nav');
    if (nav) {
        if (this.isShow) {
            nav.classList.remove('show-nav');
        } else {
            nav.classList.add('show-nav');
        }
    }
 }

}


